/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export const IDENTITY_CONFIG = {
  authority: process.env.REACT_APP_OAUTH2AUTHORITY || '',
  client_id: process.env.REACT_APP_OAUTH2CLIENTID || '',
  redirect_uri: window.location.origin + '/oauth2-callback',
  response_type: 'code',
  automaticSilentRenew: true,
  loadUserInfo: false,
  scope: 'openid profile email',
};
